import { Suspense } from 'react'
//Router
import { BrowserRouter } from 'react-router-dom'
//Contexts
import { I18nContextProvider } from '../context/I18nProvider'
import { ItinerariesProvider } from '../context/ItinerariesProvider'
//REACT QUERY
import { QueryClientProvider, QueryClient } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'

//Componentes
import Layout from '../layout/Layout'
import Loader from '../components/Loader'

//Rutas
import Router from './Router'

const BASE_URL = process.env.REACT_APP_BASENAME_URL
//Create client
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            staleTime: 0,
            cacheTime: 0,
            // staleTime: 1000 * 60, //1m //Luego de cuanto tiempo que la data es considerada desactualizada.
            // cacheTime:  El default es 5 minutos //El tiempo que la data es guardada en memoria, luego de este tiempo sera borrada.
        },
    },
})

function App() {
    return (
        <Suspense fallback={<Loader />}>
            <BrowserRouter basename={BASE_URL}>
                <I18nContextProvider>
                    <QueryClientProvider client={queryClient}>
                        <ItinerariesProvider>
                            <Layout>
                                <Router />
                            </Layout>
                        </ItinerariesProvider>
                        <ReactQueryDevtools />
                    </QueryClientProvider>
                </I18nContextProvider>
            </BrowserRouter>
        </Suspense>
    )
}

export default App
